<template>
    <div>
        <div v-if="loading" style="border: 2px solid var(--v-primary-base);padding:20px;text-align:center">
            <v-progress-circular indeterminate color="var(--v-primary-base)"></v-progress-circular>
        </div>
        <div v-else-if="entity && entity_type && ui_editor_adhoc_code">
          <DynamicComponentRenderer
              :schema="entity_type.schema"
              :code="entity_type.ui_config.editor_template"
              :options="entity_type.ui_config.editor_options"
              :actions_catalog="actions_catalog"
              :company_id="entity.company_id"
              v-model="entity.payload"
          />
        </div>
        <div v-else-if="entity && entity_type" style="border: 2px solid var(--v-primary-base);padding:3px">
            <RecursivePayloadOnSchemaEditor :schema="entity_type.schema" :value="entity.payload" :key_to_show="intern_key" :intern_key="intern_key" readonly></RecursivePayloadOnSchemaEditor>
        </div>
    </div>
</template>
    
<script>
import GenericTableComponent from '@/components/GenericTableComponent.vue'
import RecursivePayloadOnSchemaEditor from '@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue'
import { EntityInstanceApiRepository, EntityTypeApiRepository } from '@/modules/entities/infra/EntitiesApiRepositories'
import DynamicComponentRenderer  from '@/modules/entities/infra/DynamicComponentRenderer.vue'
export default {
    name: "EntityInstanceUI",
    components: {
      RecursivePayloadOnSchemaEditor,
      DynamicComponentRenderer
    },
    data() {
      return {
          entity_inst_repo: null,
          entity_type_repo: null,
          entity: null,
          entity_type: null,
          loading: true,
      }
    },
    inject: ['registerSave'],
    props: {
      entity_instance_id: {
        type: String,
        required: true,
      },
      intern_key: {
        type: String,
        required: false,
        default: '',
      },
    },
    async mounted() {
      this.entity_inst_repo = new EntityInstanceApiRepository();
      this.entity_type_repo = new EntityTypeApiRepository();
      await this.loadEntity();
      this.registerSave(this.save)
      console.log('eeeeeeeeeeeeeeee',this.ui_editor_adhoc_code)
      
    },
    methods: {
      async loadEntity(){
        this.loading = true;
        this.entity = await this.entity_inst_repo.get_instance_by_id(this.entity_instance_id);
        this.entity_type = await this.entity_type_repo.get_type_by_id(this.entity.entity_type_id, true);
        this.loading = false;
        //this.composed_key = this.key_to_show + ' ('+this.entity_type.name+')';
      },
      async save(){
        await this.entity_inst_repo.save(this.entity)
      }
    },
    computed:{
      ui_editor_adhoc_code(){
            if(this.entity_type && this.entity_type.ui_config && this.entity_type.ui_config.editor_template){
                return this.entity_type.ui_config.editor_template
            }
            return null
        },

      actions_catalog(){
        if (this.entity_type && this.entity_type.actions_catalog) {
          return this.entity_type.actions_catalog;
        }
        return [];
      }
    }
    
  };
  </script>
  
  <style scoped>
  .nested-section {
    padding-left: 10px;
    /*border-left: 1px solid #ccc; */
    margin-top: 10px;
  }
  </style>
    